import ActionTypes from '../constants';

const initialState = {
    vehicleCodes: {},
    vehicleCode: {},
    newCode: {}
    // loading: false,
};

const vehicleCodeReducer = (state = initialState, action) => {
    switch (action.type) {
        // case ActionTypes.LOADING:
        //     return {
        //         ...state,
        //         loading: true
        //     }
        case ActionTypes.GETVEHICLECODESUCCESS:
            return {
                ...state,
                vehicleCodes: action.payload,
            }
        case ActionTypes.GETVEHICLECODEBYIDSUCCESS:
            return {
                ...state,
                vehicleCode: action.payload,
            }
        case ActionTypes.SAVEVEHICLECODESUCCESS:
            return {
                ...state,
                newCode: action.payload,
            }
        default:
            return state;
    }
}

export default vehicleCodeReducer;